// src/services/medicineInventoryService.js
import apiClient from "./apiClient";
import {
  formatMedicineInventoryFields,
  normalizeMedicineInventoryList,
  normalizeMedicineInventoryResponse,
} from "../utils/nameFormatUtils";

const API_URL = `/medicinesinventory`; // Use relative path since apiClient has baseURL

// Display-only fields enriched on the client (e.g. from invoice lookup).
// MedicineInventoryDTO does not accept these — Jackson rejects unknown fields.
const MEDICINE_INVENTORY_CLIENT_ONLY_FIELDS = [
  "supplierName",
  "supplier_name",
  "invoiceNumber",
  "invoice_number",
  "fromName",
  "from_name",
];

const stripMedicineInventoryClientOnlyFields = (data = {}) => {
  if (!data || typeof data !== "object") return data;
  const cleaned = { ...data };
  MEDICINE_INVENTORY_CLIENT_ONLY_FIELDS.forEach((field) => {
    delete cleaned[field];
  });
  return cleaned;
};

export const createMedicineInventory = async (product) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.post(
      API_URL,
      formatMedicineInventoryFields(stripMedicineInventoryClientOnlyFields(product))
    );
    return normalizeMedicineInventoryResponse(response.data);
  } catch (error) {
    console.error("Error creating medicine:", error);
    throw error;
  }
};

export const updateMedicineInventory = async (id, product) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.put(
      `${API_URL}/${id}`,
      formatMedicineInventoryFields(stripMedicineInventoryClientOnlyFields(product))
    );
    return normalizeMedicineInventoryResponse(response.data);
  } catch (error) {
    console.error("Error updating medicine:", error);
    throw error;
  }
};

export const getMedicineInventoryList = async () => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(API_URL);
    return normalizeMedicineInventoryList(response.data);
  } catch (error) {
    console.error("Error fetching medicine:", error);
    throw error;
  }
};

//new enpoint for getting existing batch numbers by machineId
export const getExistingBatchNumbers = async (medicineId) => {
    try {
        // apiClient will automatically add organizationId as query param via interceptor
        const response = await apiClient.get(`${API_URL}/batchNumbers/id/${medicineId}`);
        return normalizeMedicineInventoryList(response.data);
    } catch (error) {
        console.error("Error fetching existing batch numbers:", error);
        throw error;
    }
};

export const deductMedicineInventory = async (medicineName, dosage, duration) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.post(`${API_URL}/deduct`, {
      medicineName,
      dosage,
      duration
    });
    return normalizeMedicineInventoryResponse(response.data);
  } catch (error) {
    console.error("Error deducting inventory:", error);
    throw error;
  }
};

// Function to update multiple inventory records by medicineId
export const updateInventoryRecordsByMedicineId = async (medicineId, updateData) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.put(
      `${API_URL}/updateByMedicineId/${medicineId}`,
      formatMedicineInventoryFields(stripMedicineInventoryClientOnlyFields(updateData))
    );
    return normalizeMedicineInventoryResponse(response.data);
  } catch (error) {
    console.error("Error updating inventory records by medicineId:", error);
    throw error;
  }
};
